import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import { Frame } from "@shopify/polaris";
import "@shopify/polaris/build/esm/styles.css";
import { store } from "./store/store";
import Home from "./pages/Home";
import ChoosePlacementPage from "./pages/onboarding/ChoosePlacementPage";
import SettingsShell from "./pages/settings/SettingsShell";
import BarsListPage from "./pages/settings/BarsListPage";
import BarEditorPage from "./pages/settings/BarEditorPage";
import AppSettingsPage from "./pages/settings/AppSettingsPage";
import TemplatesPage from "./pages/templates/TemplatesPage";
import AnalyticsPage from "./pages/analytics/AnalyticsPage";
import NavigationMenuComponent from "./components/NavigationMenu";
import AppBridgeErrorBoundary from "./components/AppBridgeErrorBoundary";
import AppBridgeProvider from "./components/AppBridgeProvider";
import AppFooter from "./components/AppFooter";
import { ROUTER_BASENAME } from "./config/env";

/** Sidebar links only — home/dashboard opens at "/" by default (not a nav item). */
const NAV_LINKS = [
  { label: "Templates", destination: "/templates" },
  { label: "Analytics", destination: "/analytics" },
  { label: "Settings", destination: "/settings/store" },
];

const navMatcher = (link, currentLocation) => {
  const path = currentLocation.pathname;
  if (link.destination === "/settings/store") {
    return path === "/settings/store" || path.startsWith("/settings/");
  }
  if (link.destination === "/templates") {
    return path === "/templates" || path.startsWith("/templates/");
  }
  if (link.destination === "/analytics") {
    return path === "/analytics" || path.startsWith("/analytics/");
  }
  return false;
};

function AppContent() {
  return (
    <AppBridgeProvider>
      <AppBridgeErrorBoundary>
        <Frame>
          <NavigationMenuComponent navigationLinks={NAV_LINKS} matcher={navMatcher} />
          <div
            className="age-app-routes-root"
            style={{
              minHeight: "100%",
              minWidth: "100%",
              backgroundColor: "var(--p-color-bg, #f6f6f7)",
              boxSizing: "border-box",
            }}
          >
            <div className="age-app-main age-app-main--stable">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/onboarding/choose" element={<ChoosePlacementPage />} />
                <Route path="/templates" element={<TemplatesPage />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/settings" element={<SettingsShell />}>
                  <Route index element={<Navigate to="/settings/bars" replace />} />
                  <Route path="bars" element={<BarsListPage />} />
                  <Route path="bars/:id" element={<BarEditorPage />} />
                  <Route path="store" element={<AppSettingsPage />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
            <AppFooter />
          </div>
        </Frame>
      </AppBridgeErrorBoundary>
    </AppBridgeProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter basename={ROUTER_BASENAME || undefined}>
        <AppContent />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
